import { Component, OnInit } from '@angular/core';
import { FullLogoComponent } from '../../includes/full-logo/full-logo.component';
import { RouterLink } from '@angular/router';
import { NgClass } from '@angular/common';
import { FacebookLogoComponent } from "../../includes/facebook-logo/facebook-logo.component";
import { LinkedinLogoComponent } from "../../includes/linkedin-logo/linkedin-logo.component";

@Component({
  selector: 'pc-navigation',
  standalone: true,
  imports: [
    FullLogoComponent,
    RouterLink,
    NgClass,
    FacebookLogoComponent,
    LinkedinLogoComponent
],
  templateUrl: './navigation.component.html',
  styleUrl: './navigation.component.scss'
})
export class NavigationComponent implements OnInit {
  toggledDropdown: boolean = false;
  toggledMobileMenu: boolean = false;

  ngOnInit(): void {
    // throw new Error('Method not implemented.');
  }

  toggleDropdown(e: Event): void {
    this.toggledDropdown = !this.toggledDropdown;
  }
  closeMenus(e: Event): void {
    this.toggledDropdown = false;
    this.toggledMobileMenu = false;
  }
  toggleMobileMenu(e: Event): void {
    this.toggledMobileMenu = !this.toggledMobileMenu;
  }
}
